

const store = {
  state: {
    clientId:'',
    token:"testcode"
  },
  getters: {
    clientId(state){
      return  state.clientId
    }
  },
  mutations: {
    setClientId(state,id){
      state.clientId = id
    },
    setToken(state,token){
      state.token = token
    }
  },
  actions: {

  }
}

export default store
